<section fxLayoutAlign="end center">
  <button (click)="main.open = true"><i class="fa fa-bars fa-2x menu"></i></button>
</section>
